import { useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router";

import Footer from "./Footer";
import { getUtms } from "@/lib/getUtms";
import bgTopRight from "@/assets/bg-top-right.png";
import bgBottomLeft from "@/assets/bg-bottom-left.png";
import bgBottomRight from "@/assets/bg-bottom-right.png";

const Layout = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isLegalPage = pathname.startsWith("/legal/");
  const prevPathRef = useRef(null);

  // Capture UTM params on mount
  useEffect(() => {
    let params = false;
    for (const entry of searchParams.entries()) {
      if (!params) params = {};
      if (entry[0]?.includes("utm_")) params[entry[0]] = entry[1];
    }
    if (params) sessionStorage.setItem("utmParams", JSON.stringify(params));
  }, []);

  // Capture returnURL on mount
  useEffect(() => {
    const returnURL = searchParams.get("returnURL");
    if (returnURL) sessionStorage.setItem("returnURL", returnURL);
  }, []);

  // Track page views
  useLayoutEffect(() => {
    const referrer = prevPathRef.current || document.referrer;
    prevPathRef.current = pathname;

    setTimeout(() => {
      if (window.dataLayer) {
        const utms = getUtms() || {};
        window.dataLayer.push({
          event: "page_view",
          page_name: pathname,
          page_referrer: referrer,
          utm_source: utms.utm_source || undefined,
          utm_medium: utms.utm_medium || undefined,
          utm_campaign: utms.utm_campaign || undefined,
          utm_content: utms.utm_content || undefined,
        });
      }
    }, 0);
  }, [pathname]);

  return (
    <div className="relative bg-white min-h-dvh flex flex-col overflow-hidden">
      {/* Background decorations */}
      <div className={`absolute top-0 right-0 w-full md:w-[554px] h-[92px] md:h-[136px] pointer-events-none overflow-hidden ${isLegalPage ? "hidden lg:block" : ""}`}>
        <img src={bgTopRight} alt="" className="absolute top-0 left-0 h-full w-[157.76%] max-w-none" />
      </div>
      <div className={`absolute bottom-0 left-0 w-full md:w-[565px] h-[272px] md:h-[413px] pointer-events-none overflow-hidden ${isLegalPage ? "hidden lg:block" : ""}`}>
        <img src={bgBottomLeft} alt="" className="absolute inset-0 object-cover w-full h-full max-w-none" />
      </div>
      <div className={`hidden md:block absolute right-0 top-[533px] w-[283px] h-[279px] pointer-events-none ${isLegalPage ? "!hidden lg:!block" : ""}`}>
        <img src={bgBottomRight} alt="" className="absolute inset-0 object-cover w-full h-full max-w-none" />
      </div>

      {/* Main content */}
      <div className="relative flex flex-col items-center w-full flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
